/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-27 17:50:08 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:05:51
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Attribution Service</h1>
      <h2>What is Amazon Attribution?</h2>
      <p>
        Amazon Attribution is a free tool that helps marketers measure the
        impact of their non-Amazon marketing efforts on Amazon sales. It
        provides insights into how different marketing channels drive shopping
        activity on Amazon.
      </p>
      <h2>How do I enable Amazon Attribution?</h2>
      <p>Follow these steps to turn on Amazon Attribution:</p>
      <ul>
        <li>
          1. Sign in to the <b class="fw600">Amazon Advertising Console</b>
        </li>
        <li>
          2. Expand the global navigation and select
          <b class="fw600">Measurement and Reporting</b>
        </li>
        <li>3. Click on <b class="fw600">Amazon Attribution</b></li>
        <li>4. Fill out the signup form and log in to your account</li>
        <li>5. Choose an advertiser to set up tracking for</li>
      </ul>
      <p>
        Once set up, you can track your external traffic performance and
        optimize your marketing efforts!
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>